//
//
//
//
//
//
//

import VueContentLoading from "vue-content-loading";
import { trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MaterialInputValidationLoader",
  components: {
    VueContentLoading
  },
  computed: {
    color() {
      const bodyStyles = window.getComputedStyle(document.body);
      return trim(bodyStyles.getPropertyValue("--primary")) || null;
    }
  }
});